import styled from 'styled-components';
import {match} from 'ts-pattern';

import {RowStatus} from '../../../types/api/api';

export const ImportVehicleListRowFrame = styled.div<{$rowStatus: RowStatus}>`
  position: relative;
  border-bottom: 1px solid ${({theme}) => theme.colors.general.separator};
  background: ${({theme, $rowStatus}) =>
    match($rowStatus)
      .with('error', () => theme.colors.palettes.red[10][100])
      .with('warning', () => theme.colors.palettes.orange[10][100])
      .with('success', () => theme.colors.palettes.white[10][100])
      .exhaustive()};
`;

export const ImportVehicleListRowIndicator = styled.div<{$rowStatus: RowStatus}>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${({theme}) => theme.getSize(1)};
  background: ${({theme, $rowStatus}) =>
    match($rowStatus)
      .with('error', () => theme.colors.severity.danger)
      .with('warning', () => theme.colors.severity.warning)
      .with('success', () => theme.colors.palettes.green[60][100])
      .exhaustive()};
`;
